import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ROUTE_SIGNUP } from '../shared/routes';

@Component({
  selector: 'app-privacy-statement',
  templateUrl: './privacy-statement.component.html',
  styleUrls: ['./privacy-statement.component.scss']
})
export class PrivacyStatementComponent implements OnInit {

  constructor(private readonly router: Router) { 
    
  }

  ngOnInit() {
  }
  onNavigateToSignUp(): void {
    this.router.navigate([`/${ROUTE_SIGNUP}`]);
  }
}
